import { createReducer, on } from '@ngrx/store';
import * as PlannerActions from './planner.actions';

export const plannerFeatureKey = 'planner';

export interface PlannerState {
  planners: Array<{ id: number; name: string }>;
  loading: boolean;
  error: string | null;
}

export const initialState: PlannerState = {
  planners: [],
  loading: false,
  error: null,
};

export const plannerReducer = createReducer(
  initialState,
  on(PlannerActions.loadPlanners, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlannerActions.loadPlannersSuccess, (state, { planners }) => ({
    ...state,
    planners,
    loading: false,
    error: null,
  })),
  on(PlannerActions.loadPlannersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
